/**
 * @description cart 模块内容注册
 */

import angular from 'angular';


/************************************** Module ***********************************************/

import { CommonModule } from '../common/common.module';


/************************************** Config ***********************************************/

import { PartnerCartRestServiceConfig } from './rest/partner-cart-rest.service.config';

import { UserCartRestServiceConfig } from './rest/user-cart-rest.service.config';

/************************************** Provider ***********************************************/

import { CartRestServiceProvider } from './rest/cart-rest-service.provider';

/************************************** Service ***********************************************/

import { CartRestService } from './rest/cart-rest.service';
import { CartRestServicesV2Provider } from './rest/cart-rest-service-v2.provider';

/************************************** 内容注册 ***********************************************/

let cartModule = angular.module("qpmn-module-cart", [CommonModule.name])

// cartModule.service({
//     cartRestService: CartRestService
// })

cartModule.provider({
    cartRestService: CartRestServiceProvider,
    cartRestServiceV2: CartRestServicesV2Provider
})

cartModule.config(["$restProvider",function ($restProvider) {
    $restProvider.configs([
        // Partner购物车请求配置
        PartnerCartRestServiceConfig.getCart,
        PartnerCartRestServiceConfig.addToCart,
        PartnerCartRestServiceConfig.deleteCartItem,
        PartnerCartRestServiceConfig.getItem,
        PartnerCartRestServiceConfig.getItemList,
        PartnerCartRestServiceConfig.mergeCart,
        PartnerCartRestServiceConfig.multiDelete,
        PartnerCartRestServiceConfig.totalPrice,
        PartnerCartRestServiceConfig.totalQty,
        PartnerCartRestServiceConfig.updateItem,
        PartnerCartRestServiceConfig.getMultiItems,
        PartnerCartRestServiceConfig.cartPreBulkOrder,
        // 匿名购物车请求配置
        UserCartRestServiceConfig.getCart,
        UserCartRestServiceConfig.addToCart,
        UserCartRestServiceConfig.deleteCartItem,
        UserCartRestServiceConfig.getItem,
        UserCartRestServiceConfig.getItemList,
        UserCartRestServiceConfig.multiDelete,
        UserCartRestServiceConfig.totalPrice,
        UserCartRestServiceConfig.totalQty,
        UserCartRestServiceConfig.updateItem,
        UserCartRestServiceConfig.getMultiItems,
    ])

}])

export { cartModule }